<template>
    <Teleport to="body">
        <div class="modal fade z:$(comment-modal-zindex)! {content:'';fixed:z:$(comment-modal-overlay-zindex);bg:#0000001A;top:0;left:0;w:full;h:full}::before" ref="root" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered adjust-margin">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title f:20!">{{ part?.title }}趴規</h3>
                        <button class="btn-close" data-bs-dismiss="modal" type="button"></button>
                    </div>
                    <div class="modal-body p:32|64!" v-html="part?.rule"></div>
                    <div class="modal-footer">
                        <button class="btn btn-primary" data-bs-dismiss="modal" type="button">我知道了</button>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script setup>
    const part = ref();
    const root = ref();

    let modal;

    const show = (target) => {
        part.value = target;
        modal.show();
    }

    defineExpose({ show });

    onMounted(() => {
        modal = new bootstrap.Modal(root.value);
    });
</script>
